import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownTimer() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-black/25 rounded-card py-4 px-6 my-6 flex items-center justify-center gap-5 flex-wrap" data-id="element-14">
      <span className="text-white/70 text-sm font-medium" data-id="element-15">
        La oferta especial termina en:
      </span>
      <div className="flex gap-2.5" data-id="element-16">
        <div className="text-center" data-id="element-17">
          <div className="bg-white text-negro-carbon font-bold text-2xl w-[52px] h-[52px] rounded-[10px] flex items-center justify-center font-display" data-id="element-18">
            {hours}
          </div>
          <div className="text-[0.65rem] text-white/55 uppercase tracking-wider mt-1" data-id="element-19">
            Horas
          </div>
        </div>
        <div className="text-center" data-id="element-20">
          <div className="bg-white text-negro-carbon font-bold text-2xl w-[52px] h-[52px] rounded-[10px] flex items-center justify-center font-display" data-id="element-21">
            {minutes}
          </div>
          <div className="text-[0.65rem] text-white/55 uppercase tracking-wider mt-1" data-id="element-22">
            Min
          </div>
        </div>
        <div className="text-center" data-id="element-23">
          <div className="bg-white text-negro-carbon font-bold text-2xl w-[52px] h-[52px] rounded-[10px] flex items-center justify-center font-display" data-id="element-24">
            {seconds}
          </div>
          <div className="text-[0.65rem] text-white/55 uppercase tracking-wider mt-1" data-id="element-25">
            Seg
          </div>
        </div>
      </div>
    </div>;
}